/**
 * @generated SignedSource<<8afc21b7162c5d8a4264d5fed0ec430d>>
 * @relayHash 97cbf82374de13a7fee4506b500e675d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e72909030ff1145f0a217b42acc62a8c16e8928ab325fe5f084a15221d14f185

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogAggAppDataQuery } from './BacklogAggAppDataQuery.graphql';

const node: PreloadableConcreteRequest<BacklogAggAppDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e72909030ff1145f0a217b42acc62a8c16e8928ab325fe5f084a15221d14f185",
    "metadata": {},
    "name": "BacklogAggAppDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
